<template>
	<div>

		{{ timer }}
	</div>
</template>	
<script>

export default{
	props:['time_elapsed'],
	data(){
		return {
			timer:"--:--:--",
			// timer:"",
			hours:0,
			minutes:0,
			secondes:0,
		}
	},
	filters: {
		prettify : function(value) {
			let data = value.split(':')
			let hours = data[0]
			let minutes = data[1]
			let secondes = data[2]
			if (minutes < 10) {
				minutes = "0"+minutes
			}
			if (secondes < 10) {
				secondes = "0"+secondes
			}
			return hours+":"+minutes+":"+secondes
		}
	},
	mounted(){
		this.start()
	},
	methods: {
		start(){
			const self=this
			window.setInterval( () => {
				if (self.timer=="--:--:--")
					self.timer=self.time_elapsed

				if (self.timer!="--:--:--"){
					let data = self.timer.toString().split(':')
					let hours = parseInt(data[0])
					let minutes = parseInt(data[1])
					let secondes = parseInt(data[2])
					if (secondes==59){
						secondes=0
						minutes++
					}
					else
						secondes++
					if (minutes==59){
						minutes=0
						hours++
					}

					if (hours < 10) 
						hours= "0" + hours; 

					if (minutes < 10) 
						minutes= "0" + minutes; 

					if (secondes < 10) 
						secondes= "0" + secondes; 

					self.timer=hours+":"+minutes+":"+secondes
				}

			}, 1000);
		}
	},

}

</script>